import React from "react";

export default function LonePanelLayout(props) {
	return <>{props.children}</>;
}
